// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2rHAW","inputWrap":"Table_inputWrap__1OsES","col":"Table_col__1N0Ye","bmiTooltip":"Table_bmiTooltip__1XBj3"};